export enum OnMultiImport {
  override = 'override',
  keepAll = 'keepAll',
}
